/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_Next_DescriptionInputs */

const en_wc_guides_next_description = /** @type {(inputs: Wc_Guides_Next_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the editor, desktop downloads and the full collection of WordCraft resources on our homepage, or put this guide into practice online.`)
};

/**
* | output |
* | --- |
* | "Find the editor, desktop downloads and the full collection of WordCraft resources on our homepage, or put this guide into practice online." |
*
* @param {Wc_Guides_Next_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_next_description = /** @type {((inputs?: Wc_Guides_Next_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_Next_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_next_description(inputs)
});
export { wc_guides_next_description as "wc.guides.next_description" }